import Form from 'react-bootstrap/Form'
import InputLayout from '../InputLayout/InputLayout'

const InputText = ({
    type = 'text',
    color = 'blue',
    error,
    errorText,
    label,
    name,
    onBlur,
    onChange,
    placeholder,
    touched,
    value,
    className,
    ...props
}) => {
    return (
        <InputLayout
            label={label}
            errorText={errorText}
            error={error}
            color={color}
            touched={touched}
            className={className}
        >
            <Form.Control
                type={type}
                className={'rounded-0 text-formPrimary'}
                placeholder={placeholder}
                isInvalid={error && touched}
                name={name}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                {...props}
            />
        </InputLayout>
    )
}

export default InputText
